<template>
    <!-- Product sales price weekly chart -->
    <v-hover>
        <template v-slot="{ hover }">
            <v-card outlined :elevation="hover ? 6 : 1" :loading="isLoading">
                <slot name="header"></slot>
                <div class="py-0">
                    <v-row align="center" class="mx-0">
                        <v-col cols="12" class="pb-0 pl-1">
                            <div id="chart">
                                <apexchart
                                    type="line"
                                    height="245"
                                    :options="chartOptions"
                                    :series="series"
                                ></apexchart>
                            </div>
                        </v-col>
                    </v-row>
                </div>

                <slot name="footer">
                    <p class="text-center">
                        <v-icon small color="grey">error_outline</v-icon>
                        <small class="ml-1 grey--text"
                            >Volume and sales price of all related
                            products</small
                        >
                    </p>
                </slot>
            </v-card>
        </template>
    </v-hover>
</template>

<script>
// import gql from "graphql-tag";
// import moment from "moment";
import VueApexCharts from "vue-apexcharts";

export default {
    name: "product-sales-price-weekly-chart",
    props: ["salesStartWeek", "salesEndWeek", "volumeList", "priceList"],
    components: { apexchart: VueApexCharts },
    data() {
        return {
            isLoading: false,
            componentKey: 0
        };
    },
    computed: {
        chartOptions() {
            let _salesStartWeek = this.salesStartWeek;
            let _salesEndWeek = this.salesEndWeek;

            let _annotations = {};

            if (_salesStartWeek && _salesEndWeek) {
                if (_salesStartWeek > _salesEndWeek) {
                    _annotations = {
                        xaxis: [
                            {
                                x: 0,
                                x2: _salesEndWeek + 0.5,
                                fillColor: "#FEB018",
                                opacity: 0.4,
                                label: {
                                    borderColor: "#FEB018",
                                    style: {
                                        fontSize: "10px",
                                        color: "#fff",
                                        background: "#FEB018"
                                    },
                                    offsetY: -40,
                                    text: " Sales"
                                }
                            },
                            {
                                x: _salesStartWeek - 0.5,
                                x2: 54,
                                fillColor: "#FEB018",
                                opacity: 0.4,
                                label: {
                                    borderColor: "#FEB018",
                                    style: {
                                        fontSize: "10px",
                                        color: "#fff",
                                        background: "#FEB018"
                                    },
                                    offsetY: -40,
                                    text: " Sales"
                                }
                            }
                        ]
                    };
                } else {
                    _annotations = {
                        xaxis: [
                            {
                                x: _salesStartWeek - 0.5,
                                x2: _salesEndWeek + 0.5,
                                fillColor: "#FEB018",
                                opacity: 0.4,
                                label: {
                                    borderColor: "#FEB018",
                                    style: {
                                        fontSize: "10px",
                                        color: "#fff",
                                        background: "#FEB018"
                                    },
                                    offsetY: -40,
                                    text: " Sales"
                                }
                            }
                        ]
                    };
                }
            }

            let _chartOptions = {
                chart: {
                    id: "product-sales-price-weekly-chart",
                    type: "line",
                    height: 245,
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: false
                    },
                    animations: {
                        enabled: false
                    }
                },
                stroke: {
                    width: [0, 1]
                },
                dataLabels: {
                    enabled: true,
                    enabledOnSeries: [1]
                },
                labels: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53
                ],
                xaxis: {
                    type: "numeric"
                    // hideOverlappingLabels: true
                    // labels: {
                    //     show: false
                    // }
                },
                yaxis: [
                    {
                        show: false,
                        title: {
                            text: "Volume"
                        },
                        labels: {
                            formatter: function(val) {
                                if (val != null) {
                                    return val.toFixed(0);
                                } else {
                                    return 0;
                                }
                            }
                        }
                    },
                    {
                        show: false,
                        opposite: true,
                        title: {
                            text: "Price"
                        },
                        labels: {
                            formatter: function(val) {
                                let _val = 0;
                                if (val != null) {
                                    _val = val.toFixed(2);
                                } else {
                                    _val = 0;
                                }
                                return `€ ${_val}`;
                            }
                        }
                    }
                ],
                fill: {
                    opacity: 1
                },
                colors: ["#0362fc", "#FF4560"],
                legend: {
                    position: "top",
                    horizontalAlign: "left",
                    offsetX: 0,
                    offsetY: 0
                },
                annotations: _annotations
            };

            // console.log("_chartOptions: ", _chartOptions);

            return _chartOptions;
        },

        series() {
            let _volumeList = this.volumeList || [];
            let _priceList = this.priceList || [];

            let _series = [
                {
                    name: "Volume",
                    type: "column",
                    data: [..._volumeList]
                },
                {
                    name: "Price",
                    type: "line",
                    data: [..._priceList]
                }
            ];

            // console.log(_series);

            return _series;
        }
    },
    watch: {
        // salesStartDate(newVal, oldVal) {
        //     console.log("salesStartDate: ", newVal, oldVal);
        // },
        // salesEndDate(newVal, oldVal) {
        //     console.log("salesEndDate: ", newVal, oldVal);
        // }
    },
    methods: {}
};
</script>